import {useDialogContext} from 'contexts/DialogContext';
import React, {useCallback} from 'react';
import {FloatingButton} from 'shared/components/Header/RoomPlanner/FloatingButton';
import {KeyboardShortcutsContent} from 'shared/components/Header/RoomPlanner/KeyboardShortcuts';
import styled from 'styled-components';
import {driver} from 'driver.js';
interface KeyboardShortcutsButtonProps {
    hasShadow?: boolean;
}

export const KeyboardShortcutsButton = ({
    hasShadow = true,
}: KeyboardShortcutsButtonProps) => {
    const {showDialog} = useDialogContext();

    const keyboardShortcutsHandler = useCallback(() => {
        try {
            driver().destroy();
        } catch (e) {}
        showDialog({
            title: 'Available <strong>Keyboard Shortcuts</strong>',
            closeButton: true,
            maxWidth: 650,
            hideFooter: true,
            message: <KeyboardShortcutsContent />,
            hideYesButton: true,
            hideNoButton: true,
            className: 'custom-rounded',
            headerClass: 'center-secondary',
        });
    }, [showDialog]);

    return (
        <Button
            $hasShadow={hasShadow}
            className="keyboard-shortcuts-button"
            icon="keyboard.svg"
            onClick={keyboardShortcutsHandler}
            title="Keyboard Shortcuts"
        />
    );
};

const Button = styled(FloatingButton)<{$hasShadow?: boolean}>`
    ${({$hasShadow = true}) => {
        if (!$hasShadow) {
            return `
                box-shadow: none !important;
                border: 1px solid gray;
            `;
        }
    }}
`;
